<template>
    <div class="main-container">
      <!-- Author: Vaishnavi
        Date: 10/12/2019
        Issue Description: Breadcrumb alignment -->
  
      <div class="margintop-32">
        <tl-tabs :tabs="tabs" :selected="tabIndex" @changeTab="parentTabChange">
          <tl-tab>
            <selected-employee-bulk></selected-employee-bulk>
          </tl-tab>
          <tl-tab>
            <selected-employee></selected-employee>
          </tl-tab>
        </tl-tabs>
      </div>
      <footer>
        <bottom-action-container>
          <template slot="end">
            <btn-grp class="form-button">
              <btn text="Next" type="primary"  @click="next" />
            </btn-grp>
          </template>
        </bottom-action-container>
      </footer>
    </div>
  </template>
  
  <script>
  import { mapActions, mapGetters } from "vuex";
  import selectedEmployee from "./selectedEmployee.vue";
  import selectedEmployeeBulk from "./selectEmployeeBulk.vue"  
  export default {
    components: {
        selectedEmployee,
        selectedEmployeeBulk,
    },
    data() {
      return {
        tabIndex: 0,
        breadcrumbList: [
          {
            name: "Company",
            url: `/dashboard/${this.$route.params.entity_index}/organisation`,
          },
          {
            name: "Employee Directory",
            url: `/dashboard/${this.$route.params.entity_index}/organisation/employees`,
          },
        ],
        tabs: [
          {
            header: "Bulk Upload",
          },
          {
            header: "Select Employee",
          },
        ],
        showTag: true,
        showSuccessMsg: false,
        actionTypeVar: "",
        showPopup: false,
        employeeData: [],
        activeList: [],
        existList: [],
      };
    },
    mounted() {
      
    },
    computed: {
      ...mapGetters({
        getleid: "onboard/legal_entities/legal_entity_ID",
      }),
      le_id() {
        if (this.$route.params.entity_index) {
          return this.getleid(this.$route.params.entity_index);
        }
        return this.getleid(0);
      },
      requestParams() {
        return {
          le_id: this.le_id,
        };
      },
    },
    methods: {
      
  
      
  
     

      next() {
      this.$router.push({
        path: `/payroll/run/${
          this.$route.params.entity_index ? this.$route.params.entity_index : 0
        }/lopsandrlopForOffPayroll`
      });
    },
      backToOrg() {
        this.showSuccessMsg = false;
        this.$router.push({
          path: "dashboard/organisation/employees",
        });
      },
      parentTabChange(tabIndex) {
        this.tabIndex = tabIndex;
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  @import "@/scss/components/margins.scss";
  
  </style>
  
  
  